import { render, staticRenderFns } from "./AppFurnishWeb.vue?vue&type=template&id=a34bb652&"
import script from "./AppFurnishWeb.vue?vue&type=script&lang=js&"
export * from "./AppFurnishWeb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports